import { RestService } from "@sinossi/mates-react-library"

import {
	CreateLandlordRequest,
	CreateLandlordResponse,
	PaginatedResponse,
	UserRequest,
	Users,
} from "models"

export class LandlordService {
	static createLandlord = (request: CreateLandlordRequest, callback: any, catchCallback: any) => {
		RestService
			.post<CreateLandlordResponse>("/api/create-landlord", request)
			.then(callback)
			.catch(catchCallback)
	}

	static associateLandlord = (assetId: string, landlordId: string, callback: any, catchCallback: any) => {
		RestService
			.post(`/api/asset/${assetId}/landlord`, { landlordId })
			.then(callback)
			.catch(catchCallback)
	}

	static searchLandlordAccounts = (
		request: UserRequest,
		callback: any,
		catchCallback: any,
	) => {
		RestService
			.post<PaginatedResponse<Users>>("/api/account/filter", request)
			.then(callback)
			.catch(catchCallback)
	}
}
